<div class="shared-modal position-relative">
    <div class="crossbtn text-end" (click)="onNoClick()">
        <img class="align-top"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close | Luminous" />
    </div>
    <div class="text-center" *ngIf="!isNotified">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/bell.svg'" alt="Notification | Luminous" />
        <h4 class="mt-4 mb-5">Get notified when product is<br> available</h4>
        <div class="mb-4  justify-content-center">
            <div class="form-box mx-auto">
                <input type="number" *ngIf="!data.pinCode" [(ngModel)]="pinCode" placeholder="Enter your Pincode"
                    class="cst-form-control" />
                <input type="email" [(ngModel)]="emailId" placeholder="Enter your Email" class="cst-form-control mt-3" />
                <button class="primaryBtn w-100 mt-3" (click)="onSubmit()">Submit</button>
            </div>
        </div>
    </div>
    <div class="text-center" *ngIf="isNotified">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/tick.svg'" alt="Notification | Luminous" />
        <h4 class="mt-4 mb-5 text-lowercase firstLetterCapital">You’ll be notified on {{emailId}} </h4>
    </div>
</div>
